import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./index.scss";
import axios from "axios";
import SignupForm from "../../components/devis/signUp";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { LogoIcon } from "../../assets/icons/LogoIcon";
import Stepper from "../../components/devis/stepper";
import Step2Form from "../../components/devis/step2Form";
import { LogoSimpleIcon } from "../../assets/icons/LogoSimpleIcon";

const DevisPage = () => {
  const [step, setStep] = useState(1);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    company: "",
    KBIS: null,
    KBIS1: "not applicable",
    activitySector: "",
    SIRET: "",
    SIREN: "",
    servicesDemandes: "",
    budgetEstime: "",
    description: "",
    dateSoumission: "",
    pieceJointe: null,
    devise: "EUR",
  });
  const handleNext = async () => {
    const isValid = await handleSubmit();

    if (isValid && step < 3) {
      setStep(step + 1);
    }
  };

  const handlePrevious = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (field, e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, [field]: file }));
  };
  const validateForm = () => {
    const errors = {};
    if (step === 1) {
      if (!formData.prenom) errors.prenom = "Le prénom est requis";
      if (!formData.nom) errors.nom = "Le nom est requis";
      if (!formData.email) errors.email = "L'email est requis";
      if (!formData.phone) errors.phone = "Le numéro de téléphone est requis";
      if (!formData.password) errors.password = "Le mot de passe est requis";
      if (!formData.company)
        errors.company = "Le nom de la compagnie est requis";
      if (!formData.activitySector)
        errors.activitySector = "Le secteur d'activité est requis";
      if (!formData.KBIS1) errors.KBIS1 = "Le KBIS est requis";
      if (!formData.SIRET) errors.SIRET = "Le SIRET est requis";
      if (!formData.SIREN) errors.SIREN = "Le SIREN est requis";
      if (formData.password !== formData.confirmPassword)
        errors.confirmPassword = "Les mots de passe ne correspondent pas";
    }
    if (step === 2) {
      if (!formData.company)
        errors.company = "Le nom de la compagnie est requis";
      if (!formData.activitySector)
        errors.activitySector = "Le secteur d'activité est requis";
      if (!formData.KBIS) errors.KBIS = "Le KBIS est requis";
      if (!formData.SIRET) errors.SIRET = "Le SIRET est requis";
      if (!formData.SIREN) errors.SIREN = "Le SIREN est requis";
      if (!formData.servicesDemandes)
        errors.servicesDemandes = "Les services demandés sont requis";
      if (!formData.budgetEstime)
        errors.budgetEstime = "Le budget estimé est requis";
      if (!formData.description)
        errors.description = "La description est requise";
      if (!formData.dateSoumission)
        errors.dateSoumission = "La date de soumission est requise";
    }
    return errors;
  };
  const checkEmailExistence = async (email, currentUserId) => {
    const response = await axios.get(
      `https://api.gestiondevis.msit-demo.fr/users/check-email`,
      {
        params: { email, currentUserId },
      }
    );
    return response.data.exists;
  };

  const handleSubmit = async () => {
    const errors = validateForm();
    setFormErrors(errors);

    const isValid = Object.keys(errors).length === 0;
    if (!isValid) return false;

    const user = {
      firstname: formData.prenom,
      lastname: formData.nom,
      email: formData.email,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      phone: formData.phone,
      role: "visitor",
      company: formData.company,
      activitySector: formData.activitySector,
      SIRET: formData.SIRET,
      SIREN: formData.SIREN,
    };

    if (step === 2) {
      try {
        const exists = await checkEmailExistence(user.email);
        if (exists) {
          toast.error(
            "Cet email est déjà utilisé. Veuillez en saisir un autre."
          );
          return false;
        }

        const devisData = {
          activitySector: formData.activitySector,
          company: formData.company,
          servicesDemandes: formData.servicesDemandes,
          budgetEstime: formData.budgetEstime,
          description: formData.description,
          dateSoumission: formData.dateSoumission,
          devise: formData.devise,
          SIRET: formData.SIRET,
          SIREN: formData.SIREN,
        };

        const formDataToSend = new FormData();
        formDataToSend.append("user", JSON.stringify(user));
        formDataToSend.append("devis", JSON.stringify(devisData));

        if (formData.KBIS) {
          formDataToSend.append("KBIS", formData.KBIS);
        }
        if (formData.pieceJointe) {
          formDataToSend.append("pieceJointe", formData.pieceJointe);
        }

        await axios.post(
          "https://api.gestiondevis.msit-demo.fr/users/createDevisAndUser",
          formDataToSend,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        toast.success("Utilisateur et devis créés !");
        return true; // ✅ le devis a bien été créé
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la création");
        return false;
      }
    }

    // Étape 1 : juste validation, pas de requête
    return true;
  };

  return (
    <div className="signup-page">
      <div className="container-devis">
        <div className="row d-flex align-items-center justify-content-center w-100">
          <div className="col-md-2 mt-3">
            <LogoIcon />
          </div>
          <div className="col-md-10">
            <Stepper currentStep={step} />
          </div>
        </div>

        <Form onSubmit={(e) => e.preventDefault()}>
          {step === 1 && (
            <SignupForm
              formData={formData}
              handleChange={handleChange}
              formErrors={formErrors}
            />
          )}

          {step === 2 && (
            <Step2Form
              formData={formData}
              handleChange={handleChange}
              formErrors={formErrors}
              handleFileChange={handleFileChange}
            />
          )}

          {step === 3 && (
            <div className="step-3">
              {" "}
              <LogoSimpleIcon />
              <h2>
                Nous avons bien reçu <br />
                votre demande !
              </h2>
              <p>
                Un outil exclusif développé par notre cabinet de <br />
                conseils pour visualiser votre potentiel de croissance.
              </p>
            </div>
          )}

          <div className="signup-box ps-0 d-flex justify-content-between mt-3 pt-0 ps-3 gap-3">
            {step === 2 && (
              <Button className="create-btn w-100" onClick={handlePrevious}>
                Retour
              </Button>
            )}
            {step < 3 ? (
              <Button
                onClick={handleNext}
                className={`create-btn w-100 ${
                  step !== 1 ? "submit-style" : ""
                }`}
              >
                {step === 1 ? <>Suivant</> : <>Envoyer</>}
              </Button>
            ) : (
              <></>
            )}
          </div>
        </Form>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </div>
  );
};

export default DevisPage;
